'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      visible: true
    };
  },

  computed: {
    theme: function theme() {
      try {
        return this.$theme.getTheme();
      } catch (error) {
        return '';
      }
    }
  },
  watch: {
    theme: function theme() {
      var _this = this;

      if (weex.config.env.platform != 'iOS') {
        this.visible = false;
        setTimeout(function () {
          return _this.visible = true;
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./~/@dolphinweex/weex-theme/packages/weex-theme-view/index.vue
// module id = 304
// module chunks = 0 1